<template>
  <div style="display: flex;flex-direction: column;justify-items: center;align-items: center">
    <div class="outside">
      <el-carousel indicator-position="outside" height="380px">
        <el-carousel-item  v-for="(item,index) in imgList" :key="index" >
          <!-- <img :src="require('@/assets/img/'+item.url)"/>-->
          <img :src="item.imageUrl"/>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="page">

      <!-- <div class="home-notice">
         <div>最新公告</div>
         <div><img :src="require('@/assets/img/home-notice.png')" style="width: 16px;height: 16px"/>　公最新公告最新公告最新公告最新公告告</div>
       </div>
   -->

      <div class="home-new-main">
        <div>
          <div class="home-title">新闻中心<span class="home-title-2">NEWS</span></div>
          <div class="home-title-last" @click="openTap('new',1)" >更多 <img :src="require('@/assets/img/more.png')" style="width: 16px;height: 16px;margin-left: 1px"/></div>
        </div>
        <div class="home-new-main-list">
          <div>
            <el-carousel indicator-position="outside"  style="height: 100%;width: 100%" >
              <el-carousel-item  v-for="(item,index) in newDate" :key="index"  >
                <img :src="item.coverImage" @click="open(item)"  />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div >
            <div class="home-new-main-list-content" v-for="(item,index) in newDate" @click="open(item)" >
              <div>{{item.articleTitle.length > 26 ? item.articleTitle.substring(0,26)+"..." : item.articleTitle}}</div>
              <div>{{item.createTime}}</div>
            </div>
          </div>
        </div>
      </div>







      <!--
          <div class="home-new-block">
            <div>
              <div></div>
              <div style="font-size: 25px;">媒体报道</div>
              <div style="color: #b4bccc;margin-bottom: 10px">News announcement</div>
              <div><img src="~@/assets/img/new-img.jpg" style="height: 200px;width: 260px;margin: 10px" /></div>
              <div>公交驾驶员消毒不怠慢 做乘客安全卫士</div>
              <div class="home-title-last" style="margin: 10px">更多 <img :src="require('@/assets/img/more.png')" style="width: 16px;height: 16px;margin-left: 1px"/></div>
            </div>
            <div>
              <div></div>
              <div style="font-size: 25px;">媒体报道</div>
              <div style="color: #b4bccc;margin-bottom: 10px">News announcement</div>
              <div><img src="~@/assets/img/new-img.jpg" style="height: 200px;width: 260px;margin: 10px" /></div>
              <div>公交驾驶员消毒不怠慢 做乘客安全卫士</div>
              <div class="home-title-last" style="margin: 10px">更多 <img :src="require('@/assets/img/more.png')" style="width: 16px;height: 16px;margin-left: 1px"/></div>
            </div>
            <div>
              <div></div>
              <div style="font-size: 25px;">媒体报道</div>
              <div style="color: #b4bccc;margin-bottom: 10px">News announcement</div>
              <div><img src="~@/assets/img/new-img.jpg" style="height: 200px;width: 260px;margin: 10px" /></div>
              <div>公交驾驶员消毒不怠慢 做乘客安全卫士</div>
              <div class="home-title-last" style="margin: 10px">更多 <img :src="require('@/assets/img/more.png')" style="width: 16px;height: 16px;margin-left: 1px"/></div>
            </div>
          </div>
      -->

      <!--<div class="home-new-main">-->
      <!--<div>-->
      <!--<div class="home-title">产业布局<span class="home-title-2">PARTY CONSTRUCTION</span></div>-->
      <!--<div class="home-title-last">更多 <img :src="require('@/assets/img/more.png')" style="width: 16px;height: 16px;margin-left: 1px"/></div>-->
      <!--</div>-->
      <!--<div class="home-new-main-list">-->
      <!--<div>-->
      <!--<el-carousel indicator-position="outside"  style="height: 100%;width: 100%" >-->
      <!--<el-carousel-item  v-for="(item,index) in industryData" :key="index"  >-->
      <!--<img :src="item.coverImage" @click="open(item)"  />-->
      <!--</el-carousel-item>-->
      <!--</el-carousel>-->
      <!--</div>-->
      <!--<div >-->
      <!--<div class="home-new-main-list-content" v-for="(item,index) in industryData" @click="open(item)" >-->
      <!--<div>{{item.articleTitle.length > 26 ? item.articleTitle.substring(0,26)+"..." : item.articleTitle}}</div>-->
      <!--<div>{{item.createTime}}</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->



      <div class="home-new-main">
        <div>
          <div class="home-title">党建专栏<span class="home-title-2">PARTY CONSTRUCTION</span></div>
          <div class="home-title-last" @click="openTap('party',1)">更多 <img :src="require('@/assets/img/more.png')" style="width: 16px;height: 16px;margin-left: 1px"/></div>
        </div>
        <div class="home-new-main-list">
          <div>
            <el-carousel indicator-position="outside"  style="height: 100%;width: 100%" >
              <el-carousel-item  v-for="(item,index) in partyData" :key="index"  >
                <img :src="item.coverImage" @click="open(item)"  />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div >
            <div class="home-new-main-list-content" v-for="(item,index) in partyData" @click="open(item)" >
              <div>{{item.articleTitle.length > 26 ? item.articleTitle.substring(0,26)+"..." : item.articleTitle}}</div>
              <div>{{item.createTime}}</div>
            </div>
          </div>
        </div>
      </div>


      <!--  <div class="home-class-block">
          <el-carousel :interval="4000" type="card" height="200px">
            <el-carousel-item v-for="item in 6" :key="item">
              <div>1223123123</div>
            </el-carousel-item>
          </el-carousel>
        </div>-->

      <div></div>
    </div>
  </div>

</template>

<script>
  export default {
    name: "home",
    data() {
      return {
        img:[],
        newDate:[],
        partyData:[],
        industryData:[],
         imgList: [
        /*  {url:  'new-img.jpg'},
          {url:  'new-2.jpg'},
          {url:  'new-3.jpg'},
          {url:  'new-4.jpg'}*/
        ]
      }
    },
    mounted: function () {
      this.getNew()
      this.getParty()
      this.getImg()
    },
    methods: {
      open(obj){
        this.$router.push({path:'/new-details',query: {id:(obj.id),title: this.title,classType:obj.classType}})
      },
      openTap(name,openTap){
        //this.$parent.open(name)
        this.$router.push({
          name: name,
          query:{
            id : openTap
          }
        })
        //this.openTap = this.$route.path
      },
      getImg(){
        this.$http({
          url: this.$http.adornUrl('/website/getCarouselPictures'),
          method: 'post',
          data: this.$http.adornData({
            "belongCity":16,
            "infoType":0,
            "pageSize":6,
            "page":1
          })
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.imgList = data.data
          } else {
          }
        })
      },
      getNew(){
        this.$http({
          url: this.$http.adornUrl('/website/getNews'),
          method: 'post',
          data: this.$http.adornData({
            "belongCity":16,
            "infoType":0,
            "pageSize":6,
            "page":1
          })
        }).then(({data}) => {
           if (data && data.code === 0) {
            this.newDate = data.data.list
             for(let i in this.newDate){
               this.$set(this.newDate[i], 'classType', data.data.classType);
             }
           } else {
           }
        })
      },
      getParty(){
         this.$http({
          url: this.$http.adornUrl('/website/getPartyBuilding'),
          method: 'post',
          data: this.$http.adornData({
            "belongCity":16,
            "infoType":0,
            "pageSize":6,
            "page":1
          })
        }).then(({data}) => {
          this.state  = false
          if (data && data.code === 0) {
            this.partyData = data.data.list
            for(let i in this.partyData){
              this.$set(this.partyData[i], 'classType', data.data.classType);
            }
           } else {
           }
        })
      },
      getIndustry(){
        this.state  = true
        this.$http({
          url: this.$http.adornUrl('/website/getIndustry'),
          method: 'post',
          data: this.$http.adornData({
            "belongCity":16,
            "infoType":0,
            "pageSize": 6,
            "page":1
          })
        }).then(({data}) => {
          this.state  = false
          if (data && data.code === 0) {
             this.industryData = data.data.instructions
          } else {
           }
        })
      }
    }
  }
</script>
<style scoped>
  .page{
    text-align: left;
    user-select: none;
    width: 1200px;
  }
  .page > div {
    margin-top: 50px;
  }

  .home-title{
    font-weight: 900;
    float: left;
    font-size: 21px;
    color: #4d4d4d;
    line-height: 30px;
    font-family: Source Han Sans CN;
  }

  .home-title-2{
    font-size: 17px;
    color: #d0d0d0;
    margin-left: 10px;
  }

  .home-title-last{
    color: #8c939d;
    font-size: 16px;
  }

  .outside {
    margin-top: 0px !important;
    height: 400px;
    width: 100%;
  }


  .home-notice{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 800px;
     border: #2072bb 1px solid;
  }

  .home-notice > div:nth-child(1){
    background-color: #2072bb;
    color: white;
    padding: 10px 40px;
  }

  .home-notice > div:nth-child(2){
    padding: 10px 10px 10px 10px ;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .home-new-main{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .home-new-main > div:nth-child(1){
    border-bottom: #a5a5a5 solid 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .home-new-main-list{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 20px;
    height: 330px;
  }

  .home-new-main-list > div{
    flex: 1;
    width: 100%;
    margin: 20px;
    height: 100%;
  }

  .home-new-main-list > div:nth-child(2) > div{
     padding: 15px 0px;
    border-bottom: 1px dashed #d6d5d5;

  }

  .home-new-main-list-content{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .home-new-main-list-content > div:nth-child(1){
    width: 80%;
  }
  .home-new-main-list-content > div:nth-child(2){
    width: 20%;
    text-align: end;
  }


  .home-new-block{
    height: 400px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .home-new-block > div{
    flex:1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 350px;
    padding: 10px;
    background-color: #f0f3f9;
    margin: 20px;
  }

  .home-new-main-list-content:hover{

    color: red;

  }
</style>



// WEBPACK FOOTER //
// src/views/modules/home.vue